import {Component, EventEmitter, Inject, Input, LOCALE_ID, Output} from '@angular/core';
import {FileUploadModule} from "primeng/fileupload";
import {ConfigService} from "../../../services/config.service";
import {config} from "rxjs";
import {RestBackendService} from "../../../services/rest-backend.service";
import {Router} from "@angular/router";
import {ConfirmationService, MessageService} from "primeng/api";
import {GlobalService} from "../../../services/global.service";
import {UploadFile} from "../../../dto/UploadFile";
import {DataViewModule} from "primeng/dataview";
import {NgForOf, NgIf} from "@angular/common";
import {ConfirmDialogModule} from "primeng/confirmdialog";

@Component({
    selector: 'app-image-manager',
    standalone: true,
    imports: [
        FileUploadModule,
        DataViewModule,
        NgIf,
        NgForOf,
        ConfirmDialogModule
    ],
    templateUrl: './image-manager.component.html',
    styleUrl: './image-manager.component.css'
})
export class ImageManagerComponent {
    imgNamefilter: string = "";
    imgIdFilter: string = "";
    listUploadFile: Array<UploadFile> = new Array<UploadFile>();
    totalImage: number = 20;
    displayImageCenter: boolean = false;
    @Input() imgSelectable: Boolean = true;
    @Input() imgSelected: UploadFile = new UploadFile();
    @Output() selectImageEvent = new EventEmitter<UploadFile>();

    constructor(protected restBack: RestBackendService,
                public route: Router,
                protected messageService: MessageService,
                protected confirmationService: ConfirmationService,
                public global: GlobalService,
                protected config: ConfigService,
                @Inject(LOCALE_ID) public locale: string) {
    }


    getImgList(table: any) {
        this.global.progressBar = true;
        var observable = this.restBack.doGet("lnd/file/get_list?" +
            "page=" + (table != null ? table.first / 12 : 0) +
            "&nrpp=" + (table != null ? table.rows : 12) +
            "&id=" + this.imgIdFilter +
            "&name=" + this.imgNamefilter
        );
        observable.subscribe({
            next: (result: any) => {
                var status = result["status"];
                if (status == 200) {
                    this.listUploadFile = result["entity"];
                    this.totalImage = result["total"];
                } else if (status == 401) {
                    this.gotoLogin();
                }

            },
            error: (e) => {
                this.messageService.clear();
                this.messageService.add({
                    severity: 'error',
                    summary: $localize`:@@Error:Error`,
                    detail: $localize`:@@Server side error:Server side error`
                });
            },
            complete: () => {
                this.global.progressBar = false
            }
        });
    }

    openImageCenter(tbl: any) {
        this.displayImageCenter = true;
        this.getImgList(tbl);

    }

    selectImage(img: UploadFile) {
        this.imgSelected = img;
        // this.imgSelectable = false;

        this.selectImageEvent.emit(img);
    }

    deleteIMG(id: number, tbl: any) {

        this.confirmationService.confirm({
            message: $localize`:@@Are you sure to delete?:Are you sure to delete?`,
            header: $localize`:@@Delete:Delete`,
            acceptLabel: $localize`:@@Yes:Yes`,
            rejectLabel: $localize`:@@No:No`,
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.global.progressBar = true;
                var observable = this.restBack.doGet("lnd/file/delete" +
                    "?id=" + id
                );
                observable.subscribe({
                    next: (result: any) => {
                        var status = result["status"];
                        if (status == 200) {
                            this.getImgList(tbl);
                            this.messageService.clear();
                            this.messageService.add({
                                severity: 'info',
                                summary: $localize`:@@Delete:Delete`,
                                detail: $localize`:@@The image was deleted:The image was deleted`
                            });
                        }

                    },
                    error: (e) => {
                        this.messageService.clear();
                        this.messageService.add({
                            severity: 'error',
                            summary: $localize`:@@Error:Error`,
                            detail: $localize`:@@Server side error:Server side error`
                        });
                    },
                    complete: () => {
                        this.global.progressBar = false;
                    }

                });
            }
        });
    }

    gotoLogin() {
        console.log((new Error()).stack);
        localStorage.removeItem("user");
        this.route.navigate(['admin']).then(() => {
            window.location.reload();
        });

    }

    getCenterHeight(): number {
        var elements = document.getElementsByClassName("doc-main-div");
        // // @ts-ignore
        // @ts-ignore
        return elements[0].offsetHeight;

    }

    copyToClipboard(text: string) {
        var input = document.body.appendChild(document.createElement("input"));
        input.value = text;
        input.focus();
        input.select();
        document.execCommand('copy');
        // @ts-ignore
        input.parentNode.removeChild(input);
        this.messageService.clear();
        this.messageService.add({
            severity: 'info',
            summary: $localize`:@@Copy:Copy`,
            detail: $localize`:@@The address was copied.:The address was copied.`
        });
    }

    getDirection(): string {
        if (this.locale == "fa") {
            return "rtl";
        } else {
            return "ltr";
        }
    }


    protected readonly JSON = JSON;
}


